import React, {useState} from 'react';
import ReactCountryFlag from 'react-country-flag';
import './flag-select.scss';

const countries = [
    {name: 'Англия', code: '+44', countryCode: 'GB'},
    {name: 'Германия', code: '+49', countryCode: 'DE'},
    {name: 'Франция', code: '+33', countryCode: 'FR'},
    {name: 'Польша', code: '+48', countryCode: 'PL'},
    {name: 'Россия', code: '+7', countryCode: 'RU'},
];

const FlagSelect = ({onSelect, selectedCountry}) => {
    const [isOpen, setIsOpen] = useState(false);

    const handleCountrySelect = (country) => {
        onSelect(country);
        setIsOpen(false);
    };

    return (
        <div className="flag-select-wrapper">
            <div className="flag-select-container">
                <div
                    className="flag-select-toggle"
                    onClick={() => setIsOpen(!isOpen)}
                >
                    <ReactCountryFlag countryCode={selectedCountry.countryCode} svg className="flag-icon"/>
                </div>
                {isOpen && (
                    <div className="flag-select-dropdown">
                        {countries.map((country) => (
                            <div
                                key={country.code}
                                className="flag-option"
                                onClick={() => handleCountrySelect(country)}
                            >
                                <ReactCountryFlag countryCode={country.countryCode} svg className="flag-icon"/>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default FlagSelect;
